import React, {useMemo} from 'react'
import {S3Client} from '@aws-sdk/client-s3'
import {Upload} from '@aws-sdk/lib-storage'
import {AssistantApi} from '../services/AssistantApi.service'
import {captureError} from '../lib/sentry'

const s3 = new S3Client({
    region: 'sa-east-1',
})

/**
 * Faz upload de múltiplos arquivos para o Amazon S3.
 * @param files Os arquivos a serem enviados.
 * @param path O caminho (prefixo) onde os arquivos devem ser salvos no S3.
 * @returns Um array com os document_id dos uploads bem-sucedidos.
 */
export const uploadFilesToS3 = async (
    files: File[],
    path: string,
    organization_id: string,
    user_id: string,
    assistant_id: string,
    message_guid?: string
): Promise<string[]> => {
    const api = new AssistantApi()

    const results = await Promise.allSettled(
        files.map((file) =>
            api.uploadS3PresignedUrl(
                path,
                user_id,
                organization_id,
                file,
                assistant_id,
                message_guid
            )
        )
    )

    const documentIds: string[] = []
    let errorMessage = ''

    results.forEach((result, index) => {
        const file = files[index]

        if (result.status === 'fulfilled') {
            documentIds.push(result.value.document_id)
            return
        }

        captureError(result.reason, {
            context: 'uploadFilesToS3',
            fileName: file.name,
            path,
            organization_id,
            user_id,
            assistant_id,
        })

        if (!errorMessage) {
            errorMessage =
                result.reason?.response?.data?.detail ||
                result.reason?.response?.data?.message ||
                `Falha ao enviar o arquivo "${file.name}".`
        }
    })

    if (errorMessage) {
        throw new Error(errorMessage)
    }

    return documentIds
}
